import { take } from "rxjs/operators";

export function takeOnce<T>() {
    return take<T>(1);
}
